<template>
  <auth-container
    @signIn="$emit('signIn', true)"
  ></auth-container>
</template>

<script>
import AuthContainer from '@/app/modules/auth/container/auth-container.vue';

export default {
  name: 'auth',
  components: {
    AuthContainer,
  },
};
</script>

<style scoped>
</style>
